<template>
  <div>
    <!-- Iconos -->
    <!-- Pagina de Ejemplo -->
    <!-- https://www.npmjs.com/package/@fortawesome/vue-fontawesome#usage -->
    <!-- https://fontawesome.com/icons?d=gallery&p=2 -->
    <div
      id="icons"
      class="uk-section"
    >
      <font-awesome-icon icon="user" />
      <font-awesome-icon icon="user" />

      <font-awesome-icon icon="envelope" />

      <font-awesome-icon icon="address-book" />
      <font-awesome-icon icon="phone" />
      <button @click="getUnitWheits">
        getUnitWheits
      </button>
    </div>
    <section id="switchher">
      <div class="uk-container uk-container-center">
        <h3 class="uk-margin-top">
          Tab autoplayer
        </h3>
        <ul
          class="uk-tab"
          data-uk-tab="{connect:'#my-id'}"
        >
          <li><a href="">Tab 1</a></li>
          <li><a href="">Tab 2</a></li>
          <li><a href="">Tab 3</a></li>
        </ul>
        <ul
          id="my-id"
          class="uk-switcher uk-margin"
        >
          <li>
            <a
              id="autoplayer"
              href="#"
              data-uk-switcher-item="next"
            />
            This slide contains a hidden link, that selects the next slide when clicked. The click is simulated by jacascript to mimic autoplay.
          </li>
          <li>Content 2</li>
          <li>Content 3</li>
        </ul>
      </div>
    </section>
    <section id="draggable1">
      <hr>
      <section>
        <h1>Draggable</h1>
        <hr>
        <div class="uk-card uk-card-default uk-padding">
          <div class="uk-header">
            <h3 class="uk-title">
              Items
            </h3>
            <button
              class="uk-button uk-button-primary"
              @click="insertDragAndDrop"
            >
              insertar en el DragAndDrop
            </button>
          </div>
          <div class="uk-body">
            <div class="line-in-middle">
              <draggable
                v-model="items"
                drop-zone-id="1"
                class="drop-zone"
              >
                <template #item="{item}">
                  <div style="margin: 10px">
                    <div
                      class="draggable-item uk-text-center"
                      style="background: red"
                    >
                      <h5 style="font-weight: bold">
                        {{ item.description }}
                      </h5>
                    </div>
                  </div>
                </template>
              </draggable>
            </div>
          </div>
        </div>
      </section>

      <hr>
      <section>
        <h1>Draggable</h1>
        <hr>
        <div class="uk-card uk-card-default uk-padding">
          <div class="uk-header">
            <ul data-uk-tab="{connect:'#my-id'}">
              <li class="uk-active">
                <a href="#">Left</a>
              </li>
              <li><a href="#">Item</a></li>
              <li><a href="#">Item</a></li>
              <li class="uk-disabled">
                <a>Disabled</a>
              </li>
            </ul>
          </div>
          <div class="uk-body">
            <ul
              id="my-id"
              class="uk-switcher uk-margin"
            >
              <li>...</li>
              <li>...</li>
              <li>...</li>
            </ul>
          </div>
        </div>
      </section>
    </section>
    <section id="table">
      <div
        uk-grid
        style="display: flex; justify-content: center"
      >
        <div class="uk-width-1-2">
          <table class="uk-table uk-table-striped uk-table-divider">
            <thead>
              <tr>
                <!-- <th >Titulo 1</th> -->
                <th
                  colspan="4"
                  class="uk-text-center"
                >
                  Titulo 1
                </th>
              </tr>
              <tr>
                <th>Titulo 1</th>
                <th>Titulo 2</th>
                <th>Titulo 3</th>
                <th>Titulo 4</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="3">
                  Table Data 1
                </td>
              </tr>
              <tr>
                <td>Table Data 4</td>
                <td>Table Data 5</td>
                <td>Table Data 6</td>
                <td>Table Data 6</td>
              </tr>
              <tr>
                <td>Table Data 7</td>
                <td>Table Data 8</td>
                <td>Table Data 9</td>
                <td>Table Data 9</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { defineComponent } from 'vue'
import { VueDraggableNext } from 'vue-draggable-next'
export default defineComponent({
  components: {
    draggable: VueDraggableNext
  },
  data () {
    return {
      enabled: true,
      list: [
        { name: 'John', id: 1 },
        { name: 'Joao', id: 2 },
        { name: 'Jean', id: 3 },
        { name: 'Gerard', id: 4 }
      ],
      dragging: false
    }
  }
})
</script>
